import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";


class CalculatorList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            calculators: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveCalculators();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveCalculators();
        }
    }

    async retrieveCalculators() {
        const url = 'calculator/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                calculators: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    render() {
        if (!this.state.calculators) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Вычислители'}
                    url={'calculators'}
                    data={this.state.calculators}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    fields={[
                        {
                            title: 'Название',
                            name: 'title',
                            linkPattern: '/financial/calculator/detail/:linkParam',
                            linkParam: 'id',
                            linkTarget: '_blank',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(CalculatorList)